import { render, staticRenderFns } from "./BaseVerticalMenu.vue?vue&type=template&id=6f5dd4fc&scoped=true&"
import script from "./BaseVerticalMenu.vue?vue&type=script&lang=js&"
export * from "./BaseVerticalMenu.vue?vue&type=script&lang=js&"
import style0 from "./BaseVerticalMenu.vue?vue&type=style&index=0&id=6f5dd4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5dd4fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
